




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
@Component({
  components: {
    BaseIcon,
  },
})
export default class BaseButtonIcon extends Vue {
  @Prop() href!: string
  @Prop() target!: string
  @Prop({ default: 'normal' }) size!: string
  @Prop({ default: 'transparent' }) colorScheme!: 'white' | 'transparent'
  @Prop() iconName!: string
  @Prop() position!: string
  @Prop() secondIcon!: boolean
  @Prop() secondIconName!: string
  @Prop() border!: boolean

  get tagName(): string {
    return this.href ? 'a' : 'button'
  }

  get role(): string | undefined {
    return this.href ? 'button' : undefined
  }

  get iconTagName(): string | undefined {
    return this.secondIcon ? 'base-icon' : undefined
  }
}
